import { render, staticRenderFns } from "./GoogleWorkspaceWizard.vue?vue&type=template&id=dc0fae3c&"
import script from "./GoogleWorkspaceWizard.vue?vue&type=script&lang=js&"
export * from "./GoogleWorkspaceWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports